import $ from 'jquery';

const selectors = {
	el: '.js-promocode',
	canvas: '.js-promocode canvas',
	imageSrc: 'images/promokod/bg.jpg'
};

const renderDraw = () => {

	const testRetina = $('body').hasClass('is-retina');

	const draw = fogContext => {

		const bg = new Image();
		let iwidth = 300;
		let iheight = 70;

		if (testRetina) {
			iwidth *= 2;
			iheight *= 2;
			$(selectors.el).addClass('mod--retina');
			$(selectors.canvas).attr('width', iwidth).attr('height', iheight);
		}

		bg.src = selectors.imageSrc;

		bg.onload = () => {
			fogContext.drawImage(bg, 0, 0, iwidth, iheight);
			$(selectors.el).addClass('state-load');
		};
	};

	const getEraser = (imagedata, fogImagedata, elemCount, diameter, radius) => {
		// воспользовавшись знани¤ми из геометрии за 7 класс, преобразовываем массив пикселов
		let i = 0;
		let m;
		let n;
		let ab;
		let bc;
		while (i <= elemCount) {
			// определ¤ю координаты точки в матрице. m Ч номер в строке, n Ч номер строки

			/*
			 каждый элемент массива это не массив ргба, а отдельна¤ компонетна цвета, то есть дл¤ нулевого элемента
			 0 - р
			 1 - г
			 2 - б
			 3 - а

			 дл¤ m = i / 4 элемента:
			 i	 - р
			 i + 1 - г
			 i + 2 - б
			 i + 3 - а


			 c
			 |
			 |\
			 | \
			 |  \
			 |   \
			 |____\
			 b	 a

			 ac должно быть меньше radius

			 a Ч центр круга

			 */
			m = i / 4;
			if (m < diameter) {
				n = 0;
			} else {
				n = 0;
				while (m >= diameter) {
					m -= diameter;
					n++;
				}
			}

			bc = radius - m;
			if (bc < 0) {
				bc = -bc;
			}

			ab = radius - n;
			if (ab < 0) {
				ab = -ab;
			}

			if (Math.sqrt(bc * bc + ab * ab) < radius) {
				// если пиксел попал в круг, то мен¤ю его цвет как на нижнем холсте, иначе оставл¤ю цвет на такой как на верхнем холсте

				fogImagedata.data[i] = imagedata.data[i];	 // r
				fogImagedata.data[i + 1] = imagedata.data[i + 1]; // g
				fogImagedata.data[i + 2] = imagedata.data[i + 2]; // b
				fogImagedata.data[i + 3] = imagedata.data[i + 3]; // a
			}

			i += 4;
		}
	};

	const eraser = (e, context, fogContext, radius, device, ithis) => {
		/**
		 * ѕока в эту функцию передаютс¤ только рабочий контекст, радиус (пока он используетс¤ дл¤ задани¤ стороны квадрата ластика) и объект event.
		 * ѕозже, нам понадобитс¤ добавить сюда передачу второго контекста
		 */

		let mouseX;
		let mouseY;
		let diameter = radius * 2;

		if (e.offsetX) {
			mouseX = e.offsetX;
			mouseY = e.offsetY;
		}
		else if (e.layerX) {
			mouseX = e.layerX;
			mouseY = e.layerY;
		} else {
			mouseX = -1000;
			mouseY = -1000;
		}

		if (device === 'mobile') {
			const x = e.pageX - ithis.offset().left;
			const y = e.pageY - ithis.offset().top;

			if ((x > 0) && (y > 0)) {
				mouseX = x;
				mouseY = y;
			}
		}

		if (testRetina) {
			mouseX *= 2;
			mouseY *= 2;
			diameter *= 2;
			radius *= 2;
		}

		// Ётот вариант ластика нам не подходит:
		// context.clearRect(mouseX, mouseY, radius, radius);
		// вместо него используем такой: сначала из нижнего холста получаем значени¤ цветов пикселов, попавших под ластик
		const imagedata = context.getImageData(mouseX - radius, mouseY - radius, diameter, diameter);
		const fogImagedata = fogContext.getImageData(mouseX - radius, mouseY - radius, diameter, diameter);
		const elemCount = diameter * diameter * 4;


		getEraser(imagedata, fogImagedata, elemCount, diameter, radius);

		// «атем замен¤ем этими пикселами пикселы на рабочем холсте:
		fogContext.putImageData(fogImagedata, mouseX - radius, mouseY - radius);
	};
	const loadPromoSale = () => {
		const saleTextBlock = $('.md-promo-card__visual.state-load');
		saleTextBlock.addClass('canvas-promo-load');
	};

	$(document).ready(function () {

		document.addEventListener('touchstart', function () {
		}, true);

		const canvas = document.getElementById('working-canvas');
		const fogCanvas = document.getElementById('fog-canvas');
		const context = canvas.getContext('2d');
		const fogContext = fogCanvas.getContext('2d');

		if (canvas.getContext && fogCanvas.getContext) {
			draw(fogContext);
		}

		// for desktop
		$(fogCanvas).bind('mousedown', function (e) {
			eraser(e, context, fogContext, 15);
			$(fogCanvas).bind('mousemove', function (ev) {
				eraser(ev, context, fogContext, 15);
			});
		});

		$(fogCanvas).bind('mouseup', function () {
			$(fogCanvas).unbind('mousemove');
		});

		// for mobile
		$(fogCanvas).on('touchmove', function () {
			$(fogCanvas).on('vmousemove', function (event) {
				eraser(event, context, fogContext, 15, 'mobile', fogCanvas);
			});
		});

	});
	$(window).on('load', function () {
		loadPromoSale();
	});
};

const render = () => {
	renderDraw();
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/promokod/promokod.js